import { render, staticRenderFns } from "./register-process-phone.vue?vue&type=template&id=1c0fc930&scoped=true&"
import script from "./register-process-phone.vue?vue&type=script&lang=js&"
export * from "./register-process-phone.vue?vue&type=script&lang=js&"
import style0 from "./register-process-phone.vue?vue&type=style&index=0&id=1c0fc930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0fc930",
  null
  
)

export default component.exports